module.exports = __webpack_public_path__ + "img/GEMZ.a9122861.svg";